import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PanelGroup, Panel, PanelResizeHandle } from 'react-resizable-panels';
import Header from '../../components/ui/Header';
import SymbolList from './components/SymbolList';
import TradingChart from './components/TradingChart';
import PositionsPanel from './components/PositionsPanel';
import useLanguage from '../../hooks/useLanguage';
import Icon from '../../components/AppIcon';

const MainTradingDashboard = () => {
  const [selectedSymbol, setSelectedSymbol] = useState(null);
  const [mobileActiveTab, setMobileActiveTab] = useState('chart');
  const { t } = useLanguage();

  const handleSymbolSelect = (symbol) => {
    setSelectedSymbol(symbol);
  };

  const mobileTabContent = () => {
    switch (mobileActiveTab) {
      case 'symbols':
        return (
          <div className="h-full">
            <SymbolList 
              onSymbolSelect={handleSymbolSelect}
              selectedSymbol={selectedSymbol}
            />
          </div>
        );
      case 'chart':
        return (
          <div className="h-full">
            <TradingChart selectedSymbol={selectedSymbol} />
          </div>
        );
      case 'positions':
        return (
          <div className="h-full">
            <PositionsPanel />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Zonex Trader - Ana Ticaret Paneli</title>
        <meta name="description" content="Profesyonel forex ticaret platformu - Canlı piyasa verileri, pozisyon yönetimi ve gelişmiş ticaret araçları" />
        <meta name="keywords" content="forex, trading, ticaret, piyasa, analiz, grafik" />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        {/* Header */}
        <Header />

        {/* Desktop Layout with Full-Width Positions */}
        <div className="hidden lg:flex h-[calc(100vh-4rem)]">
          <PanelGroup direction="vertical">
            {/* Top Section - Symbol List and Chart */}
            <Panel 
              defaultSize={70} 
              minSize={50}
              className="border-b border-border"
            >
              <PanelGroup direction="horizontal">
                {/* Left Panel - Symbol List */}
                <Panel 
                  defaultSize={20} 
                  minSize={15} 
                  maxSize={40}
                  className="border-r border-border"
                >
                  <SymbolList 
                    onSymbolSelect={handleSymbolSelect}
                    selectedSymbol={selectedSymbol}
                  />
                </Panel>

                {/* Resize Handle */}
                <PanelResizeHandle className="w-1 bg-border hover:bg-primary transition-colors cursor-col-resize" />

                {/* Right Panel - Trading Chart */}
                <Panel defaultSize={80} minSize={60}>
                  <TradingChart selectedSymbol={selectedSymbol} />
                </Panel>
              </PanelGroup>
            </Panel>

            {/* Resize Handle */}
            <PanelResizeHandle className="h-1 bg-border hover:bg-primary transition-colors cursor-row-resize" />

            {/* Bottom Section - Full-Width Positions */}
            <Panel defaultSize={30} minSize={20} maxSize={60}>
              <PositionsPanel />
            </Panel>
          </PanelGroup>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          {/* Mobile Content */}
          <div className="h-[calc(100vh-8rem)]">
            {mobileTabContent()}
          </div>

          {/* Mobile Bottom Navigation - Translated */}
          <div className="mobile-trading-tabs">
            <div className="flex">
              <button
                onClick={() => setMobileActiveTab('symbols')}
                className={`flex-1 py-3 px-2 flex flex-col items-center space-y-1 transition-colors ${
                  mobileActiveTab === 'symbols' ?'text-primary bg-primary/5 border-t-2 border-primary' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon name="List" size={20} />
                <span className="text-xs font-medium">{t('symbols')}</span>
              </button>
              
              <button
                onClick={() => setMobileActiveTab('chart')}
                className={`flex-1 py-3 px-2 flex flex-col items-center space-y-1 transition-colors ${
                  mobileActiveTab === 'chart' ?'text-primary bg-primary/5 border-t-2 border-primary' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon name="TrendingUp" size={20} />
                <span className="text-xs font-medium">{t('chart')}</span>
              </button>
              
              <button
                onClick={() => setMobileActiveTab('positions')}
                className={`flex-1 py-3 px-2 flex flex-col items-center space-y-1 transition-colors ${
                  mobileActiveTab === 'positions' ?'text-primary bg-primary/5 border-t-2 border-primary' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon name="Activity" size={20} />
                <span className="text-xs font-medium">{t('positions')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainTradingDashboard;